var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dsb-error-message",attrs:{"role":"status"}},[(_vm.error && _vm.error.message)?_c('div',{staticClass:"mt-sf-sm"},[_c('span',{staticClass:"dsb-error-icon text-danger"},[_vm._v(_vm._s(_vm.error.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }